import {IEnabledSetAction} from './types';
import {AT_ENABLED_SET} from './constants';

export const enabledSet = (
    isEnabled: boolean
): IEnabledSetAction => ({
    type: AT_ENABLED_SET,
    isEnabled
});
